import { Box, Button, Icon, ModalDialog, Spacer, Text } from '@jfs/ui-new'
import { FC, useState } from 'react'
import { StepProgressIndicator } from '../../../comps/StepsIndicator'
import { onBoardStrings } from '../../../data/static/strings'
import { styles } from './styles'

export const stepData = [
  {
    label: 'Create Account',
  },
  {
    label: 'Activate Account',
  },
  {
    label: 'Submit KYC',
  },
]

const getListView = (infoList: string) => {
  const info: any[] = infoList.split(',')
  return info.map((item) => {
    return (
      <Box>
        <Spacer direction="vertical" size={24} />
        <Text color="LIGHT_BLACK" type="h4">{`• ${item}`}</Text>
      </Box>
    )
  })
}

interface ActivateAccountProps {
  accountStatus: string
}

const ActivateAccount: FC<ActivateAccountProps> = (props) => {
  const { accountStatus } = props
  const [modalVisible, setModalVisibility] = useState(false)
  const [isDone, setIsDone] = useState(true) // made isDone to true to hide in phase 1
  const [stepsCovered] = useState(2)
  const [accStatus] = useState(accountStatus)

  if (accStatus === 'Activated' || isDone) {
    return null
  }

  const onDone = () => {
    setIsDone(true)
  }

  const closeModal = () => {
    setModalVisibility(false)
  }

  const openModal = () => {
    setModalVisibility(true)
  }

  if (accStatus === 'SubmittedKYC') {
    return (
      <Box {...styles.kycContainer} flexDirection="row">
        <Text color="GREEN">{onBoardStrings.submittedInfo}</Text>
        <Spacer direction="horizontal" size={24} />
        <Button onPress={onDone} testID='done' title={'Done'} />
      </Box>
    )
  }

  const getTitle = () => {
    return accStatus === 'activateKyc' ? onBoardStrings.updateKyc : onBoardStrings.activateAccount
  }

  return (
    <>
      <ModalDialog show={modalVisible} onDismiss={closeModal} type="Centered">
        {/* <AccountActivation closeModal={closeModal} activationStatus={activationStatus} /> */}
      </ModalDialog>
      <Box {...styles.container}>
        <StepProgressIndicator stepData={stepData} totalStepsCovered={stepsCovered} />
        <Spacer direction="vertical" size={24} />
        <Text color="BLACK_21" type="h3">
          {onBoardStrings.merchantAccount}
        </Text>
        <Spacer direction="vertical" size={24} />
        <Text color="LIGHT_BLACK" type="h4">
          {onBoardStrings.info}
        </Text>
        <Box flexDirection="row">
          <Box>{getListView(onBoardStrings.infoList)}</Box>
          <Spacer direction="horizontal" size={48} />
          <Box>{getListView(onBoardStrings.infoList2)}</Box>
        </Box>
        <Spacer direction="vertical" size={24} />
        <Box {...styles.separator} />
        <Spacer direction="vertical" size={24} />
        <Box flexDirection="row" justifyContent="space-between">
          <Box flexDirection="row" alignItems="center">
            <Icon size={16} id="INFO" />
            <Spacer direction="horizontal" size={8} />
            <Text>{onBoardStrings.doLater}</Text>
          </Box>
          <Button title={getTitle()} testID='openModal' onPress={openModal} isRound={true} />
        </Box>
      </Box>
    </>
  )
}

export { ActivateAccount }
